// script.js (circle index.html) ~sdg
'use strict'
console.time('LoadTime')

import './normalize.css'
import './style.css'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as THREE from 'three'
import * as dat from 'lil-gui'
import { MeshBasicMaterial } from 'three'

/**
 * Base
 */
// Debug
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const group = new THREE.Group()
scene.add(group)

/**
 * Axes Helper
 */
//const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)
/*
 * Objects
 */

const whiteGeometry = new THREE.CircleGeometry(0.25,)
const whiteMaterial = new THREE.MeshBasicMaterial({ color: 0xf2f2f2 })
const whiteCircle = new THREE.Mesh(whiteGeometry, whiteMaterial)
whiteCircle.position.z = 0.01

const redGeometry = new THREE.CircleGeometry( 1, 16, Math.PI * 0, Math.PI * 0.5 )
const redMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true })
const redCircle = new THREE.Mesh(redGeometry, redMaterial)

const greenGeometry = new THREE.CircleGeometry(1, 16, Math.PI * 0.5, Math.PI * 0.5)
const greenMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true })
const greenCircle = new THREE.Mesh(greenGeometry, greenMaterial)

const blueGeometry = new THREE.CircleGeometry(1, 16, Math.PI * 1, Math.PI * 0.5)
const blueMaterial = new THREE.MeshBasicMaterial({ color: 0x0000ff, wireframe: true })
const blueCircle = new THREE.Mesh(blueGeometry, blueMaterial)

const yellowGeometry = new THREE.CircleGeometry(1, 16, Math.PI * 1.5, Math.PI * 0.5)
const yellowMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00, wireframe: true })
const yellowCircle = new THREE.Mesh(yellowGeometry, yellowMaterial)

group.add(whiteCircle, redCircle, greenCircle, blueCircle, yellowCircle)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 5
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  controls.update()

  // Update group
  group.rotation.x = elapsedTime * 0.2
  group.rotation.y = elapsedTime * 0.2
  group.rotation.z = - elapsedTime * 0.5

  // Render
  renderer.render(scene, camera)

  // Call animate again on next frame
  window.requestAnimationFrame(animate)
}

animate()
console.timeEnd('LoadTime')
// EOF script.js (circle index.html) ~sdg